/** Payment / subscription actions passed through the Products checkout flow. */
export const PlanAction = {
  UPGRADE: "Upgrade",
  RENEW: "Renew",
  ACTIVATE: "Activate",
};
